var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 7.35733C4.22586 7.33333 4.71017 7.33333 5.33301 7.33333H10.6663C11.2892 7.33333 11.7735 7.33333 12.1663 7.35733M3.83301 7.35733C3.34274 7.38725 2.99492 7.45458 2.69803 7.60583C2.22762 7.8455 1.84517 8.22792 1.60549 8.69833C1.33301 9.23317 1.33301 9.93317 1.33301 11.3333V12.5C1.33301 13.9002 1.33301 14.6002 1.60549 15.135C1.84517 15.6054 2.22762 15.9878 2.69803 16.2275C3.23281 16.5 3.93287 16.5 5.33301 16.5H10.6663C12.0665 16.5 12.7665 16.5 13.3013 16.2275C13.7718 15.9878 14.1542 15.6054 14.3938 15.135C14.6663 14.6002 14.6663 13.9002 14.6663 12.5V11.3333C14.6663 9.93317 14.6663 9.23317 14.3938 8.69833C14.1542 8.22792 13.7718 7.8455 13.3013 7.60583C13.0044 7.45458 12.6566 7.38725 12.1663 7.35733M3.83301 7.35733V5.66667C3.83301 3.36548 5.69849 1.5 7.99967 1.5C10.3008 1.5 12.1663 3.36548 12.1663 5.66667V7.35733",
    stroke: "#27387D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFade);
export default __webpack_public_path__ + "static/media/arrow_fade.8867334303841a1a9ed44c8271ec8eea.svg";
export { ForwardRef as ReactComponent };